module.exports = "/_next/static/images/636cb22f96503d3134f9e7d06d3b54ff-phone-icon.svg";